import { render, staticRenderFns } from "./redPackageAgentSettlement.vue?vue&type=template&id=6bda50f6&scoped=true&"
import script from "./redPackageAgentSettlement.vue?vue&type=script&lang=js&"
export * from "./redPackageAgentSettlement.vue?vue&type=script&lang=js&"
import style0 from "./redPackageAgentSettlement.vue?vue&type=style&index=0&id=6bda50f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda50f6",
  null
  
)

component.options.__file = "redPackageAgentSettlement.vue"
export default component.exports